import React from 'react';

const TermsOfServicePage = () => {
  return (
    <div className="terms-page">
      <div className="page-header">
        <div className="container">
          <h1>Terms of Service</h1>
          <p>Understand your rights and responsibilities.</p>
        </div>
      </div>
      <section className="container py-5">
        <p className="section-description">
          This placeholder summarizes service terms. For full legal terms, please contact our legal team.
        </p>
      </section>
    </div>
  );
};

export default TermsOfServicePage;